import React, {Fragment, FunctionComponent} from "react";
import {IconButton} from "@App/Components/common/IconButton/IconButton";

type AKFContractStepProps = {
    nextStep: any
    isAKFBasePage: boolean
};

export const AKFContractStep: FunctionComponent<AKFContractStepProps> = (props: AKFContractStepProps)  => {

    return (
        <Fragment>
            <div className="overflow-hidden">
                <div
                    className={`md:w-fit ease-in-out grid grid-cols-1 xs:grid-cols-2 gap-2 mb-4 mt-4 w-full`}>
                    <IconButton
                        title={'akf Auto-Leasing'}
                        onClick={props.isAKFBasePage === false ? () => window.location.href ='https://werkstatt.repareo.de/partner/akf?akfcontracttype=1' : () => props.nextStep()}
                        icon={<Fragment/>}/>
                    <IconButton
                        title={'akf Langzeitmiete'}
                        onClick={props.isAKFBasePage === true ? () => window.location.href ='https://werkstatt.repareo.de/partner/akf-langzeitmiete?akfcontracttype=1' : () => props.nextStep()}
                        icon={<Fragment/>}/>
                </div>
            </div>
        </Fragment>
    )
}
